module.exports = __webpack_public_path__ + "static/media/arche_logo.f8a385d5.svg";